// React
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
// External libs
import { get } from 'lodash'
// Components
import OrderDetailDialogProductsSection from './OrderDetailDialogProductsSection'

const mapStateToProps = (
  { orderDetailDialogReducer: { orderId }, ordersReducer: { orders } },
  { intl: { formatMessage } },
) => {
  const order = orders.find(order => order.id === +orderId) || {
    id: 0,
    detail: { id: 0, products: [], user: {}, whims: [] },
  }
  const orderDetail = get(order, 'detail', null)
  const products = get(orderDetail, 'products', [])
  const productsByCorridor = orderDetail.productsByCorridor
  const whims = get(orderDetail, 'whims', [])

  return {
    products,
    productsByCorridor,
    whims,
  }
}

const mapDispatchToProps = {}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(OrderDetailDialogProductsSection),
)
